// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed027f10","455":"7fb680d4","977":"bb493ac2"}[chunkId] + ".chunk.js";
};